
<div id="topbar" class="align-items-center d-flex fixed-top">
  <div class="container-fluid">
    <div class="row topbar-info align-items-center">
      <!-- <div class="col-4">
        <div class="device-time d-block d-sm-none">
          <p>device time <small>14:37:00</small></p>
        </div>
      </div> -->
      <div class="col-4">
        <div class="device-time">
          <p style="width: max-content;">
            <a style="color: rgb(230, 230, 230);" href="javascript:void(0);" routerLink="/home"><i class="icofont-home"></i> HOME</a> 
            <!-- | <label class="switch1"><input type="checkbox"><span class="slider1 round1"></span></label> -->
            <button class="btn_deposit" *ngIf="userData && userData?.branch_panel_active == 1" routerLink="/deposit">deposit</button>
            <button class="btn_withdrawal" *ngIf="userData && userData?.branch_panel_active == 1" routerLink="/withdraw">withdrawal</button>
          </p>
        </div>
      </div>
      <div class="col-4 logo">
          <a href="javascript:void(0);" routerLink="/dashboard">
              <img class="img-fluid" src="assets/images/{{env.host.name}}/header-logo.png">
          </a>
      </div>
      <div class="col-4 login-time">
        <span class="mr-2">{{currentDateTime}}</span>
        <button class="login" (click)="openLogin()" *ngIf="!isLogin()">login</button>
        <button class="login ml-1" routerLink="/signup" *ngIf="env.host.signUpActive && !isLogin()" style="background:#13a613 !important;">signup</button>
        <div class="btn-group top-user-menus" *ngIf="isLogin()">
          <button type="button" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img src="http://speedcdn.io/assets/kesar-client/icons/user-client.png"> {{userData?.username}} (<b>{{userData?.available_balance}}</b>)
          </button>
          <div class="dropdown-menu">
            <p routerLink="/market-analysis">available credit: <em [ngClass]="{'credit': userData?.available_balance > 0,'debit': userData?.available_balance < 0}">{{userData?.available_balance}}</em></p>
            <p routerLink="/market-analysis">credit limit: <em>{{userData?.balance}}</em></p>
            <p routerLink="/market-analysis">winning: <em [ngClass]="{'credit': userData?.pl > 0,'debit': userData?.pl < 0}">{{userData?.pl}}</em></p>
            <p routerLink="/market-analysis">net exposer: <em [ngClass]="userData?.expose >= 0 ? 'credit' : 'debit'">{{userData?.expose}}</em></p>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/account/profile">profile</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/my-bets">my bets</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/reports/account-statement">account statement</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/reports/profit-loss">profit & loss</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/stake-setting">stake setting</a>
            <a class="dropdown-item" href="javascript:void(0);" routerLink="/change-password">change password</a>
            <a class="logout" href="javascript:void(0);" (click)="logOut()">log out</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<a *ngIf="!router.url.includes('event/detail') && userData?.branch_panel_active == 1 && wpLink != ''" class="whatsapp_link" [href]="wpLink" target="_blank"><img src="assets/images/wp_support.png"></a>

<div class="row depo_withd" *ngIf="userData && userData?.branch_panel_active == 1">
  <div class="col-6">
    <button class="btn_deposit" routerLink="/deposit">deposit</button>
  </div>
  <div class="col-6">
    <button class="btn_withdrawal" routerLink="/withdraw">withdrawal</button>
  </div>
</div>